// extracted by mini-css-extract-plugin
export var descriptionContainer = "swiper-module--description-container--5318a";
export var descriptionNote = "swiper-module--description-note--12a54";
export var descriptionSlide = "swiper-module--description-slide--492df";
export var descriptionSwiper = "swiper-module--descriptionSwiper--d4d9d";
export var descriptionText = "swiper-module--description-text--e5b6b";
export var descriptionWrapper = "swiper-module--description-wrapper--1a4f4";
export var titleSlide = "swiper-module--title-slide--a75dd";
export var titleSwiper = "swiper-module--titleSwiper--9e8df";